import { useEffect, useState, useRef } from "react"
import { consumer } from "@/lib/cable"

export type PluExtractionUpdate = {
  type: "step_update" | "extraction_complete" | "extraction_failed"
  run_id: string
  status: string
  step_timings?: Record<string, number>
  gpu_zone_count?: number
  extracted_zone_count?: number
  matched_zone_count?: number
  completeness_pct?: number
  estimated_cost_usd?: number
  error_message?: string
}

type Options = {
  communeId: string
  onComplete?: () => void
}

export function usePluExtractionChannel({ communeId, onComplete }: Options) {
  const [update, setUpdate] = useState<PluExtractionUpdate | null>(null)
  const onCompleteRef = useRef(onComplete)
  onCompleteRef.current = onComplete

  useEffect(() => {
    const subscription = consumer.subscriptions.create(
      { channel: "PluExtractionChannel", commune_id: communeId },
      {
        received(data: unknown) {
          const update = data as PluExtractionUpdate
          setUpdate(update)
          if (update.type === "extraction_complete" || update.type === "extraction_failed") {
            onCompleteRef.current?.()
          }
        },
      },
    )

    return () => {
      subscription.unsubscribe()
    }
  }, [communeId])

  return update
}
